import { motion } from "framer-motion";
import { ArrowRight, Bus } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { CLUB } from "@/data/content";

export default function Hero() {
  const go = (t) => scrollToId(t);

  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1782472003016-0a22e37bbf9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="San Siro"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 nerazzurro-gradient opacity-90" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-transparent to-[#0B0E14]/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 md:py-32 w-full">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-10 items-center">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 mb-6"
            >
              <span className="h-2 w-2 rounded-full bg-gold animate-pulse" />
              <span className="text-xs font-bold uppercase tracking-widest text-gold">Molise • Dal {CLUB.founded}</span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="font-display font-black uppercase tracking-tight leading-[0.92] text-white text-5xl sm:text-6xl lg:text-7xl"
            >
              Inter Club<br />
              <span className="text-gold">Guardialfiera</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="mt-6 max-w-xl text-lg md:text-xl text-white/80 font-medium leading-relaxed"
            >
              {CLUB.tagline}. Unisciti a noi per vivere ogni partita dell'Inter da protagonista, dalla nostra sede fino a San Siro.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-9 flex flex-wrap gap-4"
            >
              <button
                data-testid="hero-join-cta-button"
                onClick={() => go("#tesseramento")}
                className="group inline-flex items-center gap-2 rounded-full bg-gold px-7 py-4 font-bold uppercase tracking-wide text-[#0B0E14] hover:brightness-110 transition-all shadow-xl"
              >
                Diventa Socio 26/27
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                data-testid="hero-stadium-trip-button"
                onClick={() => go("#stadio")}
                className="inline-flex items-center gap-2 rounded-full border border-white/30 glass bg-white/5 px-7 py-4 font-bold uppercase tracking-wide text-white hover:bg-white/10 transition-all"
              >
                <Bus size={18} />
                Vieni a San Siro
              </button>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="hidden lg:flex justify-center"
          >
            <img src={CLUB.logo} alt="Stemma Inter Club Guardialfiera" className="w-full max-w-sm drop-shadow-2xl animate-[float_6s_ease-in-out_infinite]" />
          </motion.div>
        </div>
      </div>

      <style>{`@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-14px)}}`}</style>
    </section>
  );
}
